const features = /* @__PURE__ */ new Map([
  ["blocking", false],
  [
    "breakpoints",
    {
      xxs: "0rem",
      xs: "30rem",
      // 480px
      s: "48rem",
      // 768px
      m: "64rem",
      // 1024px
      l: "80rem",
      // 1280px
      xl: "90rem",
      // 1440px
      xxl: "120rem",
      // 1920px
      xxxl: "160rem"
      // 2560px
    }
  ],
  ["prefix", "tk"],
  [
    "attributes",
    {
      component: "data-component",
      option: "data-option",
      ref: "data-ref"
    }
  ]
]);
export {
  features
};
//# sourceMappingURL=features.js.map
